import { useSuspenseQuery } from '@tanstack/react-query'

import { GetNacionalidadesService } from '@/features/clientes/services/get-nacionalidades.service'
import { nacionalidadeClienteKeys } from '@/features/clientes/utils'

export const useSuspenseNacionalidade = () => {
  return useSuspenseQuery({
    queryKey: nacionalidadeClienteKeys.lista(),
    queryFn: async () => new GetNacionalidadesService().execute().then((res) => res.data),
  })
}
